import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface RecentResult {
  testTitle: string;
  testMode?: string;
  subjectName?: string;
  passed: boolean;
  percentageScore?: number | null;
}

@Component({
  selector: 'app-recent-activity-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './recent-activity-card.component.html',
  styleUrl: './recent-activity-card.component.css',
})
export class RecentActivityCardComponent {
  @Input() results: RecentResult[] = [];
  @Input() trendPercentage: number | null | undefined = null;
  @Input() titleKey: string = 'DASHBOARD.RECENT_RESULTS';
}
